/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .directive('accResize', ['$window', '$rootScope', function($window, $rootScope){
    var PADDING_BOTTOM = 65;
    var HEIGHT_TOP = 65;
    var PUBLIC_FOLDERS_BREADCRUMBS_HEIGHT = 64;

    return {
        link: function($scope, $elem) {
            var publicFolderFooterHeight;

            function refreshDimensions() {
                $elem.find('#body .left #menu').height($window.innerHeight - HEIGHT_TOP);
                $elem.find('#body .main #content').outerHeight($window.innerHeight);
            }

            function resizeScrollbar() {
                publicFolderFooterHeight = publicFolderFooterHeight || $elem.find('.public-folder__wrapper footer').innerHeight() || 0;

                $elem.find('#body .main #content .main > .scroller').height($window.innerHeight - HEIGHT_TOP);
                $elem.find('#body .left #menu nav .scroller').height($window.innerHeight - HEIGHT_TOP - PADDING_BOTTOM);
                $elem.find('#public-folder-table .scroller').height($window.innerHeight - HEIGHT_TOP - PUBLIC_FOLDERS_BREADCRUMBS_HEIGHT - publicFolderFooterHeight);
            }

            function broadcastResize() {
                $rootScope.$broadcast('windowResize');
            }

            setTimeout(refreshDimensions, 500);

            var rootScopeBroadcastTimeout = 0;

            $($window).resize(function(){
                if (rootScopeBroadcastTimeout) {
                    clearTimeout(rootScopeBroadcastTimeout);
                }
                rootScopeBroadcastTimeout = setTimeout(broadcastResize, 500);
                refreshDimensions();
                resizeScrollbar();
            });

            $scope.$on('resize.scroll', resizeScrollbar);
        }
    }
}]);
